module.exports = __webpack_public_path__ + "img/logoBg.462b9e28.png";